import React from 'react'
import { Col, Row } from 'react-bootstrap'
import * as Request from '../../utilities/request'
import { AppContext } from '../../App'
import { Loading } from '../ui/Loading/Loading'
import { Staff } from '../../../../back-end/common/staff'
import Select from 'react-select'
import { Search } from 'react-feather'
import DashboardCard, { HeaderBr } from './dashboardCard'
import { TestingStaff } from '../../screens/dashboard/dashboardWrapper'

interface DirectorPickerProps {
	director: TestingStaff | null
	setDirector: React.Dispatch<React.SetStateAction<TestingStaff | null>>
}

const DirectorPicker = (props: DirectorPickerProps) => {
	const { appState } = React.useContext(AppContext)

	const [staff, setStaff] = React.useState<Staff[] | null>(null)

	React.useEffect(() => {
		const getData = async () => {
			const [staffRes] = await Promise.all([Request.get(`staff`)])

			setStaff(staffRes.data.staff)
		}

		if (appState.authState.isLoggedIn) {
			getData()
		}
	}, [appState.authState])

	if (!staff) {
		return (
			<DashboardCard background="cornflower">
				<div className="center-flex">
					<Loading show />
				</div>
			</DashboardCard>
		)
	}

	return (
		<DashboardCard background="cornflower">
			<Row className="pb-2">
				<Col>
					<span className="span-body-2 span-bold span-black">Invoiced under Director</span>
				</Col>
			</Row>
			<HeaderBr color="black" />
			<Row className="pt-3">
				<Col>
					<Select
						options={staff
							.filter((staff) => staff.xpmID === staff.reportGroupStaffXpmID) // A director is assigned to their own reporting group
							.sort((a, b) => (a.name < b.name ? -1 : 1))
							.map((staff) => ({ value: staff.xpmID, label: staff.name, xpmID: staff.xpmID, id: staff.userID, role: staff.permissionID }))}
						isOptionSelected={(opt) => opt.value === props.director?.xpmID}
						onChange={(opt) => props.setDirector(opt ? { id: opt.id!, role: opt.role!, xpmID: opt.xpmID! } : null)}
						isClearable
						placeholder={
							<div className="d-flex align-items-center">
								<Search size={14} />
								<span className="pl-2">Search or select...</span>
							</div>
						}
					/>
				</Col>
			</Row>
		</DashboardCard>
	)
}

export default DirectorPicker
